import React from 'react';
import { Button } from '@fasstech/middle-design-system';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import { append, equals, findIndex, includes, length, propEq, reject } from 'ramda';

const PricingSelector = ({
  pricings,
  displayedPricings,
  selectedPricingCodes,
  onSelect,
  minimumCCNIndex,
  maxNumberOfProducts
}) => {
  const onSelectPricing = (pricingLabel, isSelected) => {
    if (isSelected) {
      onSelect((prevPricings) =>
        reject(equals(pricingLabel), prevPricings)
      );
      return;
    }

    // Blocage si on a atteint la limite de produits sélectionnables
    if (length(selectedPricingCodes) >= maxNumberOfProducts) {
      return;
    }

    onSelect((prevPricings) =>
      append(pricingLabel, prevPricings)
    );
  };

  return (
    <div
      className={'grid items-center py-4'}
      style={{
        gridTemplateColumns: `300px repeat(${displayedPricings.length}, minmax(150px, 1fr))`
      }}>
      <div className={'sticky left-0 bg-white z-10 w-full h-full'} />

      {mapIndexed(({ pricingLabel }, index) => {
        const isMinimumCCN = pricingLabel === 'Minimum CCN';
        const pricingIndex = findIndex(propEq('pricingLabel', pricingLabel), pricings);

        if (isMinimumCCN) {
          return <div key={pricingLabel} />;
        }

        const isSelected = includes(pricingLabel, selectedPricingCodes);
        const isLimitReached =
          !isSelected && selectedPricingCodes.length >= maxNumberOfProducts;

        return (
          <div key={`${index}-pricingLabel`} className={'flex justify-center items-center mx-1'}>
            <Button
              variant={isSelected ? 'primary' : 'outline'}
              onClick={() => onSelectPricing(pricingLabel, isSelected)}
              disabled={minimumCCNIndex === -1 || pricingIndex < minimumCCNIndex || isLimitReached}
              data-testid={`selectPricing-${pricingLabel}`}
            >
              {isSelected ? 'Sélectionné' : 'Sélectionner'}
            </Button>
          </div>
        );
      })(displayedPricings)}
    </div>
  );
};

export default PricingSelector;
